const columns = [
  {
    heading: "本期内容",
    links: [
      { label: "本期目录", href: "#contents" },
      { label: "解说字幕版", href: "#commentary" },
      { label: "浓缩速看", href: "#condensed" },
      { label: "混剪剪辑", href: "#mashup" },
    ],
  },
  {
    heading: "快速入口",
    links: [
      { label: "合集总入口", href: "#entry" },
      { label: "字幕版专区", href: "#commentary" },
      { label: "浓缩版打包", href: "#condensed" },
      { label: "常见问题", href: "#faq" },
    ],
  },
  {
    heading: "关于整理",
    links: [
      { label: "更新条说明", href: "#top" },
      { label: "时间线怎么排", href: "#contents" },
      { label: "字幕校对原则", href: "#commentary" },
      { label: "收录范围", href: "#faq" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-background-200/70 border-t border-background-300">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-8 h-8 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-movie-2-line" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                黑料视频
              </span>
            </div>
            <p className="text-sm leading-7 text-foreground-600 max-w-sm">
              把黑料视频合集与混剪按时间线整理好，解说、字幕版、浓缩版都能直接刷，看完梗概再决定要不要追原片。
            </p>
          </div>

          {columns.map((column) => (
            <div key={column.heading} className="md:col-span-2">
              <h4 className="font-heading text-sm font-bold text-foreground-900 mb-4">
                {column.heading}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-300 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 黑料视频 · 内容整理展示，条目梗概仅供参考
          </p>
          <p className="text-xs text-foreground-500">
            合集 · 混剪 · 解说 · 字幕版 · 浓缩版
          </p>
        </div>
      </div>
    </footer>
  );
}